import React, { useState } from 'react'
import { userSignUp } from '../../Services/AuthServices';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const useRegister = () => {

    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [phoneNumber, setPhoneNumber] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()


    const handleFirstName = (e) => {
        setFirstName(e.target.value)
    }
    const handleLastName = (e) => {
        setLastName(e.target.value)
    }
    const handleEmail = (e) => {
        setEmail(e.target.value)
    }
    const handlePassword = (e) => {
        setPassword(e.target.value)
    }
    const handleConfirmPassword = (e) => {
        setConfirmPassword(e.target.value)
    }
    const handlePhoneNumber = (phone) => {
        setPhoneNumber(phone)
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await userSignUp({ first_name: firstName, last_name: lastName, email, phone: phoneNumber, password, confirm_password: confirmPassword, user_type: 1 })
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            setIsLoading(false)
            navigate("/login")
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }



    return [
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
        confirmPassword,
        isLoading,
        handleFirstName,
        handleLastName,
        handleEmail,
        handlePhoneNumber,
        handlePassword,
        handleConfirmPassword,
        handleSubmit
    ]
}

export default useRegister